

// Menu management system using localStorage
window.MenuManager = {
    storageKey: 'closedMenus',

    isMenuExpired: function(menuId) {
        const menuElement = document.getElementById(`${menuId}-menu`);
        if (!menuElement) return false;
        
        const expiresDate = menuElement.dataset.expires;
        if (!expiresDate) return false; // No expiration date = never expires
        
        const expiry = new Date(expiresDate);
        const now = new Date();
        
        return now > expiry;
    },

    shouldShowMenu: function(menuId) {
        // Check if closed by user
        if (this.isMenuClosed(menuId)) {
            return false;
        }
        
        // Check if expired
        if (this.isMenuExpired(menuId)) {
            // console.log(`Menu "${menuId}" has expired`);
            return false;
        }
        
        return true;
    },

    // Get list of closed menus from localStorage
    getClosedMenus: function () {
        const stored = localStorage.getItem(this.storageKey);
        return stored ? JSON.parse(stored) : [];
    },

    // Add a menu to the closed list
    markMenuAsClosed: function (menuId) {
        const closedMenus = this.getClosedMenus();
        if (!closedMenus.includes(menuId)) {
            closedMenus.push(menuId);
            localStorage.setItem(this.storageKey, JSON.stringify(closedMenus));
        }
        // this.updateStatus();
    },

    // Check if a menu has been closed before
    isMenuClosed: function (menuId) {
        return this.getClosedMenus().includes(menuId);
    },

    // Clear all closed menus (for testing)
    clearClosedMenus: function () {
        localStorage.removeItem(this.storageKey);
        // this.updateStatus();
    },

    closeMenu: function (menuId, event) {
        event.stopPropagation();
        event.preventDefault();
        jQuery(`#${menuId}-menu`).removeClass('show');
        this.markMenuAsClosed(menuId);
    }

    // Update status display
    // updateStatus: function() {
    //     const closedMenus = this.getClosedMenus();
    //     const statusContent = document.getElementById('status-content');
    //     statusContent.textContent = closedMenus.length > 0 ? closedMenus.join(', ') : 'None';
    // }
};

// Show a menu if it hasn't been closed before
function showMenu(menuId) {
    if (MenuManager.isMenuClosed(menuId)) {
        alert(`Menu "${menuId}" has been closed before and won't show again.`);
        return;
    }

    if (!MenuManager.shouldShowMenu(menuId)) {
        return;
    }

    // Hide any currently showing menus
    jQuery('.slide-menu.show').removeClass('show');

    // Show the requested menu
    setTimeout(() => {
        jQuery(`#${menuId}-menu`).addClass('show');
    }, 100);
}

// Close a menu and mark it as closed
// function closeMenu(menuId) {
//     stopPropagation();
//     preventDefault();
//     $(`#${menuId}-menu`).removeClass('show');
//     MenuManager.markMenuAsClosed(menuId);
// }

// Clear storage for testing
function clearStorage() {
    MenuManager.clearClosedMenus();
    alert('Storage cleared! All menus can show again.');
}


// Initialize on page load
jQuery(document).ready(function () {
    //MenuManager.updateStatus();

    // Auto-show welcome menu if it hasn't been closed (simulate page load behavior)
    //check if navigate menu is available
    if(jQuery(`#navigate-group1-menu`).length) {
        setTimeout(() => {
            if (!MenuManager.isMenuClosed('navigate-group1')) {
                showMenu('navigate-group1');
            }
        }, 2000);
    }

    //check if promo menu is avaiable
    if(jQuery(`#promo-menu`).length) {
        setTimeout(() => {
            if (!MenuManager.isMenuClosed('promo')) {
                showMenu('promo');
            }
        }, 6000);
    }
});

// Optional: Auto-close menu when clicking outside
// $(document).on('click', function(e) {
//     if (!$(e.target).closest('.slide-menu, .test-btn').length) {
//         $('.slide-menu.show').removeClass('show');
//     }
// });




jQuery(document).ready(function () {

    //create accordion if the ul contains more than 4 list item in page-content
    // if (jQuery('.page-content ul li').length > 4) {
    //     var uls = jQuery(".page-content").find("ul");
    //     jQuery(uls).wrap("<div class='accordion' />");
    //     //console.log('i am more than 4');
    // }

    //show initial menu
    // Check if menu should show
    // if (!MenuManager.isMenuClosed('navigate-group1')) {
    //     showMenu('navigate-group1');
    // }
});

jQuery(document).ready(function() {
    // const quicknavButton = document.getElementById('quicknav_button');
    // const quicknavLongText = document.getElementById('quicknav_long-text');
    const quicknavMenu = document.getElementById('quicknav_menu');
    const quicknavMenuWrapper = document.getElementById('quicknav_menu-wrapper');

    //show text in quickmenu after time - temp
    // setTimeout(() => {
    //     jQuery(`#quicknav_long-text`).toggle('show');
    //     quicknavButton.classList.toggle('collapsed');
    // }, 3000);

    // setTimeout(() => {
    //     jQuery(`#quicknav_long-text`).toggle('show');
    //     quicknavButton.classList.toggle('collapsed');
    // }, 6000);


    var $quicknav = jQuery('#quicknav');
    if($quicknav.length === 0) {
        return; // Exit if #quicknav does not exist
    }
    var $placeholder = jQuery('#nav-placeholder');
    var navOffset = $quicknav.offset().top;
    var threshold = 20; // 20px from top
    var $quicknavLongText =jQuery('#quicknav_long-text');
    var $quicknavButton = jQuery('#quicknav_button');

    var menuShown = false;

    function showMenuLabel(){
        if(menuShown == false){
            menuShown = true;
            // setTimeout(() => {
            $quicknavLongText.addClass('show');
            $quicknavButton.removeClass('collapsed');
            // }, 3000);

            setTimeout(() => {
                $quicknavLongText.removeClass('show');
                $quicknavButton.addClass('collapsed');
            }, 2000);
        }
    }



    jQuery(window).scroll(function() {
        var scrollTop = jQuery(window).scrollTop();
        var shouldStick = scrollTop >= (navOffset - threshold);

        if (shouldStick) {
            showMenuLabel();
            $quicknav.addClass('sticky');
            $placeholder.addClass('active');
            // $quicknavLongText.addClass('show');
            // quicknavButton.addClass('collapsed');
        } else {
            $quicknav.removeClass('sticky');
            $placeholder.removeClass('active');
            // $quicknavLongText.removeClass('show');
            // $quicknavButton.removeClass('collapsed')
        }
    });

    // Recalculate on window resize
    jQuery(window).resize(function() {
        if (!$quicknav.hasClass('sticky')) {
            navOffset = $quicknav.offset().top;
        }
    });

    

    quicknavMenu.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // console.log("Menu item clicked");
        quicknavMenuWrapper.classList.toggle('active');
        // quicknavButton.classList.toggle('collapsed');
        // if (quicknavButton.classList.contains('collapsed')) {
        //     quicknavLongText.style.display = 'none';
        // } else {
        //     quicknavLongText.style.display = '';
        // }
    });
    quicknavMenuWrapper.addEventListener('click', function(e) {
        // Only hide nav if the click is on a child element (not the wrapper itself)
        if (e.target !== quicknavMenuWrapper) {
            //$quicknav.removeClass('sticky');
            quicknavMenuWrapper.classList.toggle('active');

        }
    });
});


//Countdown timer
jQuery(document).ready(function () {

    let countdown_div = document.getElementById("countdown");
    if(!countdown_div) return;
    // Set the date we're counting down to
    var countDownDate = new Date(2025, 10, 1, 15, 20, 0); // Note: month is 0-indexed, so 8 = September
    // Get today's date and time
    var now = new Date().getTime();
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    if(distance <= 0) {
        document.getElementById("countdown").innerHTML = "";
        return;
    }

    // Update the count down every 1 second
    var x = setInterval(function() {

    // Get today's date and time
    var now = new Date().getTime();
        
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
        
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var total_minutes_left = Math.floor(distance / (1000 * 60));
    // console.log(total_minutes_left);
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
    let html = "<span class='jumpsin'>Jumps in: </span>";
    if (days > 0) {
        html += "<span class='days'>" + days + "</span>";
    }
    if (hours > 0) {
        html += "<span class='hours'>" + hours + "</span>";
    }
    if (minutes > 0) {
        html += "<span class='minutes'>" + minutes + "</span>";
    }
    if (total_minutes_left < 60) {
        html += "<span class='seconds'>" + seconds + "</span>";
    }
    //html += "<span class='seconds'>" + seconds + "</span>";
    countdown_div.innerHTML = html;  
    // If the count down is over, write some text 
    if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "";
    }
    }, 1000);
});